/**
 * Призрак двери или окна: едет за курсором по ближайшей стене, пока выбран инструмент
 * «Дверь» / «Окно» или проём тянут из панели. Рисуется теми же компонентами, что настоящий
 * проём, полупрозрачно и мимо указателя — клик должен дойти до стены или холста.
 */
import { angleOf, sub } from "@/shared/lib/geometry";
import { DoorShape, WindowShape } from "@/widgets/catalog";
import { pointAlongWall, type Opening, type WallGraph } from "../../plan";

const DEG = 180 / Math.PI;

interface Props {
	ghost: Opening | null;
	graph: WallGraph;
	mmPerPx: number;
}

export const OpeningGhost2D = ({ ghost, graph, mmPerPx }: Props) => {
	const wall = ghost ? graph.walls[ghost.wallId] : undefined;
	const a = wall ? graph.nodes[wall.a] : undefined;
	const b = wall ? graph.nodes[wall.b] : undefined;
	if (!ghost || !wall || !a || !b) return null;
	const start = pointAlongWall(a, b, ghost.offset - ghost.width / 2);
	const Shape = ghost.kind === "door" ? DoorShape : WindowShape;
	return (
		<g
			opacity={0.6}
			style={{ pointerEvents: "none" }}
			transform={`translate(${start.x} ${start.y}) rotate(${angleOf(sub(b, a)) * DEG})`}
		>
			<Shape
				opening={ghost}
				wallThickness={wall.thickness}
				selected
				mmPerPx={mmPerPx}
				interactive={false}
				onPointerDown={() => {}}
			/>
		</g>
	);
};
